import React from 'react';
import { Hero } from '../components/home/Hero';
import { QuickActions } from '../components/home/QuickActions';
import { Audiences } from '../components/home/Audiences';
import { Credits } from '../components/home/Credits';
import { IslamicFinance } from '../components/home/IslamicFinance';
import { DigitalBanking } from '../components/home/DigitalBanking';
import { LandSale } from '../components/home/LandSale';
import { News } from '../components/home/News';
import { ClosingCta } from '../components/home/ClosingCta';
export function Home() {
  return <>
      <Hero data-id="element-272" data-mp="29g4yknincsx5" />
      <QuickActions data-id="element-273" data-mp="29gdb2eauxw7t" />
      <Audiences data-id="element-274" data-mp="29fvfljw0rm0y" />
      <Credits data-id="element-275" data-mp="29fbwhzumurlc" />
      <IslamicFinance data-id="element-276" data-mp="29etv6ot45n6k" />
      <DigitalBanking data-id="element-277" data-mp="2dhqi2rpos5gb" />
      <LandSale data-id="element-278" data-mp="2di8djm4iyfn6" />
      <News data-id="element-279" data-mp="2dirsctyvonwz" />
      <ClosingCta data-id="element-280" data-mp="2dj9ziln2wmjo" />
    </>;
}